import { render, staticRenderFns } from "./MoveFromWaitlist.vue?vue&type=template&id=39727aac&scoped=true&"
import script from "./MoveFromWaitlist.vue?vue&type=script&lang=js&"
export * from "./MoveFromWaitlist.vue?vue&type=script&lang=js&"
import style0 from "./MoveFromWaitlist.vue?vue&type=style&index=0&id=39727aac&prod&scoped=true&lang=css&"
import style1 from "./MoveFromWaitlist.vue?vue&type=style&index=1&id=39727aac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39727aac",
  null
  
)

export default component.exports